import { saveAs } from 'file-saver';
import { format } from 'date-fns';

import actions from './actions';
import {
  MOBILE_LOG_DATETIME_SHORT_FORMAT,
  MOBILE_LOG_DATETIME_FORMAT,
} from './constants';

const downloadMobileLog = ({ deviceId }) => (dispatch, getState) => {
  dispatch(actions.downloadMobileLog({ deviceId }));
  const allLines = getState().apps.manual.log.get('lines');

  const filename = `SauceLabs_Log_${deviceId}_${format(new Date(), MOBILE_LOG_DATETIME_SHORT_FORMAT)}.txt`;
  const blob = new Blob(
    allLines.map(
      (line) => `${format(new Date(line.timestamp), MOBILE_LOG_DATETIME_FORMAT)}\t${line.level}:\t${line.message}\n`,
    ),
    { type: 'text/plain;charset=utf-8' },
  );

  return saveAs(blob, filename);
};

export default {
  downloadMobileLog,
};
